<template>
  <div>
    <el-form
      ref="form"
      :model="party"
      :rules="rules"
      size="small"
      inline
      :disabled="isDisabled.value"
      label-position="right"
      label-width="130px"
      class="form-input-width accident-party-form"
    >
      <el-form-item
        label="伤者姓名"
        prop="name"
      >
        <el-input
          v-model="party.name"
          placeholder="请输入伤者姓名"
        />
      </el-form-item>
      <el-form-item
        label="伤者联系电话"
        prop="phone"
      >
        <el-input
          v-model="party.phone"
          placeholder="请输入伤者电话"
        />
      </el-form-item>
      <el-form-item
        label="申请人身份"
        prop="applicantStatus"
      >
        <el-input
          v-model="party.applicantStatus"
          placeholder="请输入申请人身份"
        />
      </el-form-item>
      <el-form-item
        label="伤者性别"
        prop="gender"
      >
        <el-select
          v-model="party.gender"
          placeholder="请选择"
        >
          <el-option
            label="男"
            :value="1"
          />
          <el-option
            label="女"
            :value="0"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="伤者身份证号"
        prop="identityNum"
      >
        <el-input
          v-model="party.identityNum"
          placeholder="请输入伤者身份证号码"
        />
      </el-form-item>
      <el-form-item
        label="救援医院"
        prop="hospital"
      >
        <claimsSelect
          v-model="party.hospital"
          :type="'Hospital'"
        />
      </el-form-item>
      <el-form-item
        label="人脸信息"
        prop="faceInfo"
      >
        <!-- <el-input v-model="party.faceInfo" /> -->
        <el-image
          style="width: 100px; height: 100px;margin-bottom:10px"
          :src="party.faceInfo"
        />
      </el-form-item>
      <div>
        <el-form-item
          label="申请单类型"
          prop="applicationFormType"
        >
          <el-radio
            v-model="party.applicationFormType"
            :label="0"
          >
            急诊人伤直赔申请书
          </el-radio>
        </el-form-item>
        <div>
          <span
            class="btn_primary"
          ><a
            :href="party.notification"
            target="_blank"
          >查看盖章通知书</a></span>
        </div>
      </div>
    </el-form>
    <div>
      <el-form-item
        label="医院费用总计"
        prop="totalCost"
      >
        <el-input
          v-model="party.totalCost"
          disabled
        />
      </el-form-item>
      <listing :list-data="party.treatmentListUrl" />
    </div>
  </div>
</template>

<script>
import { validIdNum, validPhone } from '@/utils/validate';
import listing from './listing';
import claimsSelect from './claimsSelect';
export default {
  components: { listing, claimsSelect },
  inject: {
    isDisabled: { default: () => ({ value: false }) },
    accident: { default: () => {} }
  },
  props: {
    party: {
      type: Object,
      require: true,
      default:()=>{
        return {};
      }
    }
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: '请填写伤者姓名' }],
        gender: [{ required: true, message: '请选择伤者性别' }],
        hospital: [{ required: true, message: '请选择医院' }],
        identityNum: [
          { required: true, message: '请输入身份证号码' },
          {
            validator(rule, value, cb) {
              if (value && !validIdNum(value)) {
                cb(new Error('请输入正确的身份证号码'));
              } else {
                cb();
              }
            }
          }
        ],
        phone: [
          { required: true, message: '请输入手机号码' },
          {
            validator(rule, value, cb) {
              if (value && !validPhone(value)) {
                cb(new Error('请输入正确的手机号码'));
              } else {
                cb();
              }
            }
          }
        ]
      }
    };
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    }
  }
};
</script>
<style lang="less">
.heading {
  margin:0 0 15px 15px;
  font-size: 16px;
  font-weight: 700;
}
.labelSt {
  margin-right:15px;
  color: #606266;
  font-size:16px;
  font-weight: 700;
}
.btn_primary{
  display: inline-block;
  width: 300px;
  height: 40px;
  line-height: 40px;
  margin-top: 20px;
  text-align: center;
  font-size: 16px;
  background: rgba(14, 189, 53, 0.1);
  color: #0EBD35; 
  border-radius: 4px;
  border: 1px solid #0EBD35;
  outline: none;
  cursor: pointer;
}
</style>
